import { Model, createModel, type DataProxy } from '@kp/js-model';
import { BaseDataProxy } from './BaseDataProxy';
import type { ModelConstructor } from '@kp/js-model/dist/Model';
import { instance as api } from '@/helpers/api';

export class BaseModel extends Model {
    protected proxy: BaseDataProxy | null = null;

    public getDataProxy(): DataProxy {
        if (!this.proxy) {
            this.proxy = new BaseDataProxy();
        }
        return this.proxy;
    }

    getId() {
        return this.get(this.getIdName());
    }

    getIdName(): string {
        return 'id';
    }

    public static async loadByProperty<T extends BaseModel>(this: ModelConstructor<T>, property: string, value: any): Promise<T | null> {
        const model = createModel(this);

        try {
            const res = await api().post('/' + model.getClassName() + '/getByProperty', {
                property,
                value
            });

            if (res.data?.data) {
                model.set(res.data.data);
                model.commit();
                model.setPhantom(false);
                return model;
            }
        } catch (e) {
            // das gibts nicht...
        }
        return null;
    }

    public static async loadById<T extends BaseModel>(this: ModelConstructor<T>, id: number): Promise<T | null> {
        const model = createModel(this);
        model.set(model.getIdName(), id);

        const proxy = model.getDataProxy();
        const res = await proxy.fetch(model);
        if (res) {
            model.set(res);
            model.commit();
            model.setPhantom(false);
            return model;
        }
        return null;
    }
}
